(function ($) {
    $(".speakers-accordion .accordion ").on('click', function () {
      $(this).toggleClass('active-text');
      $(this).siblings('').removeClass('active-text');
    });
})(jQuery);